interface CommonLocators {
    pure1Spinner: string;
}

export const COMMON_LOCATORS: CommonLocators = {
    pure1Spinner: 'pure1-spinner',
};
